export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">关于吃瓜网</h2>
        </div>

        <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <div className="flex flex-col lg:flex-row gap-8 md:gap-10 items-center">
            <div className="flex-1">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                吃瓜网51成立于2020年，是国内最具影响力的娱乐<strong>黑料</strong>聚合平台。我们深耕娱乐圈内幕，追踪<strong>网红八卦</strong>，挖掘<strong>综艺真相</strong>，致力于为吃瓜群众提供最新、最全、最真实的<strong>爆料</strong>内容。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                平台汇聚了来自全国各地的<strong>爆料</strong>投稿，覆盖明星恋情、综艺翻车、网红带货争议、影视圈潜规则等多个领域。我们坚持多方验证信息来源，确保每一条<strong>内幕消息</strong>都经得起推敲。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                无论是追星族、综艺粉还是纯粹爱<strong>吃瓜</strong>的路人，这里都是你不容错过的<strong>八卦新闻</strong>第一站。每天打开吃瓜网51，掌握娱乐圈最新<strong>爆料事件</strong>。
              </p>
            </div>
            <div className="flex-shrink-0 grid grid-cols-3 gap-6 md:gap-8 text-center">
              <div>
                <div className="text-3xl md:text-4xl font-heading text-primary-500">5年</div>
                <div className="text-xs text-foreground-500 mt-1">深耕爆料</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-heading text-primary-500">50万+</div>
                <div className="text-xs text-foreground-500 mt-1">累计爆料</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-heading text-primary-500">800万</div>
                <div className="text-xs text-foreground-500 mt-1">月活用户</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}